// extracted by mini-css-extract-plugin
export default {"container":"EditPastActivitiesApp--container--psAcA"};